import { gql } from '@apollo/client';

export const GET_AREA_BY_ID = gql`
    query GetAreaById($areaId: Long!) {
        getAreaById(areaId: $areaId) {
            id
            name
            warehouseId
            dspId
            zipcodeList
            sortingCode
        }
    }
`;

export interface AreaByIdType {
    id: string;
    name: string;
    warehouseId: string;
    dspId: string;
    zipcodeList: string[];
    sortingCode?: string | null;
}

export interface GetAreaByIdResponse {
    getAreaById: AreaByIdType | null;
}

export interface GetAreaByIdVariables {
    areaId: number;
}
